var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.94 1.5C13.93 1.5 15 2.57 15 7.56v1.88c0 4.99-1.07 6.06-6.06 6.06H7.06l-.891-.014c-4.23-.135-5.17-1.368-5.17-6.046V7.56c0-4.678.94-5.91 5.17-6.046l.89-.014zM6.737 3.004v10.991q.157.003.322.005H8.94c1.213 0 2.086-.067 2.727-.209.623-.139.932-.328 1.114-.51s.371-.49.51-1.114c.142-.64.209-1.514.209-2.727V7.56c0-1.213-.067-2.086-.21-2.727-.138-.624-.327-.932-.509-1.114s-.49-.371-1.114-.51C11.027 3.067 10.153 3 8.94 3H7.06q-.165.001-.323.004m-1.5.068a8 8 0 0 0-.904.137c-.624.139-.933.328-1.114.51s-.372.49-.51 1.114c-.143.64-.21 1.514-.21 2.727v1.88c0 1.213.067 2.086.21 2.727.138.624.328.932.51 1.114.181.182.49.371 1.114.51q.389.086.904.136z",
    clipRule: "evenodd"
  })));
};
export default Svg16;